import store from "../../store";
export const footerItemObj = {
  title: "Contact Us",
  isLink: false,
  showInMobile: false,
  items: [
    {
      icon: require("@/assets/images/home/tel.png"),
      title: "+86 21-6769-6068",
    },
    {
      icon: require("@/assets/images/home/mobile.png"),
      title: "+86 133-4129-3141",
    },
    {
      icon: require("@/assets/images/home/phone.png"),
      title: "+86 400-135-7277",
    },
    {
      icon: require("@/assets/images/home/mail.png"),
      title: "himo.industry@haier.com",
    },
    {
      icon: require("@/assets/images/home/location.png"),
      title: "Site Address",
      hideOnMobile: true,
    },
  ],
};
export const footerItems = [
  // {
  // title: "Products And Service",
  // isLink: false,
  // showInMobile: false,
  // isAboutUs: true,
  // items: [
  // ...store.state.allCategories,

  // 	{
  // 	title: "Mold Custom",
  // 	name: "Mold Custom",
  // 	url: "/MoldCustom",
  // 	id: 1,
  // }, {
  // 	id: 2,
  // 	title: "3D Printing",
  // 	name: "3D Printing",
  // 	url: "/Printing"
  // }, {
  // 	id: 3,
  // 	title: "Mold Accessories",
  // 	url: "/MoldAccessories"
  // }, {
  // 	id: 4,
  // 	title: "Product Manufacturing",
  // 	url: "/ProductManufacturing"
  // },
  // 	{
  // 		name: "After-Sale Service",
  // 		anchorName: 'worldInsertCharts',
  // 		url: "/"
  // 	}]
  // },
  {
    title: "Suppliers",
    isLink: false,
    showInMobile: false,
    items: [
      {
        name: "Steel",
        id: 5,
        url: "/404",
      },
      {
        name: "Aluminum",
        id: 5,
        url: "/404",
      },
      {
        name: "Hot Runner",
        id: 5,
        url: "/404",
      },
      {
        name: "Spare Parts",
        id: 5,
        url: "/404",
      },
      {
        name: "Plastic Particle",
        id: 5,
        url: "/404",
      },
    ],
  },
  {
    title: "About Us",
    isLink: false,
    showInMobile: false,
    items: [
      {
        name: "Company Introduction",
        url: "/about/company",
        anchorName: 1,
      },
      {
        name: "Brand Mission and Vision",
        url: "/about/mission",
        anchorName: 2,
      },
      //  ,{
      //    title: "Why Us",
      // url:"/WhyUs",
      // anchorName: 3,
      //  }
      // ,{
      //   title: "Spare Parts",
      // },{
      //   title: "Plastic Particle",
      // },
    ],
  },
];
